module.exports = __webpack_public_path__ + "static/media/powerplatform.312ceb5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/powerplatform.jpg
// module id = 867
// module chunks = 13